import { Edit, useRecordContext, useTranslate, useNotify } from "react-admin";
import { Customer } from "../../../../shared/types/types";
import UserForm from "./UserForm";

const CompanyEdit = () => {
    const notify = useNotify();

    const onError = (error: any) => {
        console.log('Error object:', error);
        console.log('Error status:', error?.status);
        console.log('Error message:', error?.message);
        console.log('Error body:', error?.body);
        console.log('Error body type:', typeof error?.body);

        let message = 'Error desconocido';

        // Si body es un objeto JSON
        if (error?.body && typeof error.body === 'object' && error.body.message) {
            message = error.body.message;
        }
        // Si body es texto plano (puede ser el mensaje directamente)
        else if (error?.body && typeof error.body === 'string' && error.body.length > 0) {
            message = error.body;
        }
        // Si message ya tiene el contenido (react-admin lo pone aquí si viene en json.message)
        else if (error?.message && typeof error.message === 'string' && error.message.length > 0 && error.message !== 'Bad Request') {
            message = error.message;
        }

        notify(message, { type: 'error' });
    };

    return (
        <Edit title={<CustomerTitle />} component="div" mutationMode="pessimistic" mutationOptions={{ onError }}>
            <UserForm formTitle={"Editar Usuario"} edit={true}/>
        </Edit>
    );
};

const CustomerTitle = () => {
    const translate = useTranslate();
    const record = useRecordContext<Customer>();
    return record ? (
        <span>
            {translate('resources.commands.title', {
                module: 'Usuario',
                reference: record.name,
            })}
        </span>
    ) : null;
};


export default CompanyEdit;
